module.exports = __webpack_public_path__ + "img/linked-account.9c572d8a.jpg";